import React from 'react';
import {
    Dialog,
    CircularProgress,
} from '@mui/material';
import { connect } from 'react-redux';

interface Props {
    loading: boolean,
    size: number,
    thickness: number,
    description: string,
    settings: any,
}

const ProgressSpinner: React.FC<Props> = props => {
    const { size, thickness, description, loading, settings } = props;

    // See-through like before: the page shows behind the loader; no extra dark backdrop.
    // Message text is dark on the light veil, or the client's loader text colour when set.
    return (
        <Dialog open={loading} fullScreen hideBackdrop PaperProps={{ style: { background: 'transparent', boxShadow: 'none' } }}>
            <div className='d-flex flex-direction-column align-items-center justify-content-center' style={{ position: 'relative', height: '100%', width: '100%' }} >
                {/* See-through veil (80% like before); the card on top stays solid. */}
                <div style={{ position: 'absolute', inset: 0, opacity: 0.8, background: settings?.Styles?.OverrideLoadingSpinnerBackgroundColor ? settings?.Styles?.OverrideLoadingSpinnerBackgroundColor : "rgba(243, 245, 247, 0.9)" }} />
                {/* Spinner and message in the middle of the screen. */}
                <div className="pb-loader-card">
                    <CircularProgress size={Math.min(size || 40, 44)} thickness={thickness} style={{ color: settings?.Styles?.OverrideLoadingSpinnerColor ? settings?.Styles?.OverrideLoadingSpinnerColor : settings?.Styles?.Primary }} />
                    {description && (
                        <div className="pb-loader-text" style={settings?.Styles?.OverrideLoadingSpinnerTextColor ? { color: settings.Styles.OverrideLoadingSpinnerTextColor } : undefined}>{description}</div>
                    )}
                </div>
            </div>
        </Dialog>
    )
}

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
    loading: state.progressSpinner.loading,
    size: state.progressSpinner.size,
    thickness: state.progressSpinner.thickness,
    description: state.progressSpinner.description,
})

export default connect(mapStateToProps)(ProgressSpinner);
